import {
  Box,
  Stack,
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  Divider,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { ReactNode } from 'react'

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

const StyledListItem = styled(ListItem)(() => ({
  height: 56,
}))

interface StyledListItemButtonProps {
  hasActionComponent: boolean
  disableRipple: boolean
}

const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== 'hasActionComponent',
})<StyledListItemButtonProps>`
  height: 100%;
  box-sizing: border-box;
  padding: 0 15px 0 ${props => (props.hasActionComponent ? 0 : 10)}px;
  overflow: hidden;
`

interface Props {
  avatarComponent: JSX.Element
  primaryText: string
  secondaryActionComponent?: ReactNode
  secondaryText?: string | JSX.Element
  hasDivider?: boolean
  isTransparent?: boolean
}

export function MediaOwnerListItemBase({
  avatarComponent,
  primaryText,
  secondaryActionComponent,
  secondaryText,
  hasDivider,
  isTransparent,
}: Props) {
  return (
    <>
      <StyledListItem
        disablePadding
        sx={{ bgcolor: isTransparent ? 'transparent' : 'white' }}
      >
        <StyledListItemButton
          hasActionComponent={!!secondaryActionComponent}
          disableRipple={false}
        >
          <ListItemAvatar>{avatarComponent}</ListItemAvatar>

          <Stack
            justifyContent="center"
            sx={{ width: '100%', overflow: 'hidden' }}
          >
            <Box
              sx={{ display: 'flex', overflow: 'hidden', marginBottom: '1px' }}
            >
              <Typography
                variant="subtitle3"
                noWrap
                color={isTransparent ? 'white' : undefined}
              >
                {primaryText}
              </Typography>
            </Box>

            {typeof secondaryText === 'string' ? (
              <Typography
                variant="caption1"
                noWrap
                sx={{ color: !isTransparent ? '#9DA3AA' : 'white' }}
              >
                {secondaryText}
              </Typography>
            ) : (
              secondaryText
            )}
          </Stack>
        </StyledListItemButton>

        {secondaryActionComponent}
      </StyledListItem>

      {hasDivider && <StyledDivider variant="inset" />}
    </>
  )
}

MediaOwnerListItemBase.defaultProps = {
  secondaryText: null,
  secondaryActionComponent: null,
  hasDivider: true,
  isTransparent: false,
}
